/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const styles = (theme) => {
    const { palette } = theme;
    return {
        customInputValidations: {
            '&.customInputValidation': {
                '&.custom-text-field': {
                    '& .MuiFormControl-root': {
                        background: '#fff',
                        border: 'solid 1px rgb(0, 0, 0, 0.23)!important',
                    },
                },
                '&.custom-date-field': {
                    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                        borderBottom: 'none',
                    },
                    '& .MuiInput-underline:before': {
                        borderBottom: 'none',
                    },
                },
                '& .MuiOutlinedInput-root': {
                    borderRadius: 0,
                    background: palette?.common?.white,
                },
                '& .MuiFormLabel-root': {
                    color: palette?.common?.black,
                },
                '&.custom-radio-field': {
                    display: 'flex',
                    alignItems: 'center',
                    '& fieldset': {
                        border: '1px solid #999',
                        margin: '-4px',
                        padding: '3px',
                    },
                    '& label': {
                        order: '2',
                        '& ~div': {
                            '&.position-relative': {
                                order: 1,
                                '& input': {
                                    position: 'relative',
                                    marginRight: '10px',
                                    marginLeft: '0',
                                },
                            },
                        },
                    },
                    '& input': {
                        paddingRight: '12px',
                        zIndex: '9999',
                        margin: '0px',
                        width: '24px',
                        height: '24px',
                        marginRight: '10px',
                        opacity: '0',
                    },
                },
            },
        },
        radioRoot: {
            padding: '0 15px',
        },
        radioLabelRoot: {
            fontSize: '1rem',
        },
    };
};

export default styles;
